<div>
	<app-company-add
		label="Add a brokerage"
		[name]="name"
		[firm]="brokerage"
		(onSubmit)="onSubmit($event)"
	></app-company-add>
</div>
